module.exports = __webpack_public_path__ + "cf20289747b3d7c98c3f093c066917db.gif";